import { LineQuantityAdjust } from "@components/molecules/line-quantity-adjust/index.client";
import { useLineItem } from "@models/interactions/use-line-item";
import { Link, CartLinePrice, Image } from "@shopify/hydrogen";
import { Markup } from "@components/atoms/markup/index.client";
import { CloseIcon } from "@components/atoms/Icons";
import { translate } from "@locales";
import classNames from "classnames";
import { CartLineItem } from "@models/interactions/cart-line-quantity-adjust";

export function LineItemDrawer({onclose}: {onclose?: ()=> void}) {
  const { models, operations } = useLineItem();

  return (
    <li
      key={models.lineId}
      className="flex justify-between items-center border rounded pl-2 pr-6 py-3"
    >
      <Image
        data={models.merchandise.image}
        className="object-cover object-center mr-5 min-w-[70px] min-h-[70px] w-[70px] h-[70px] lg:w-24 lg:h-24"
      />

      <div className="grid grid-cols-[3fr_1fr] lg:grid-cols-[2fr_1fr] w-full grid-rows-2 gap-y-4 justify-start items-start">
        <h3 className="font-medium uppercase">
          <Link
            onClick={onclose}
            to={`/products/${models.merchandise.product.handle}`}
            className="overflow-hidden text-ellipsis"
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
            }}
          >
            {models.merchandise.product.title}
          </Link>
        </h3>

        <button
          type="button"
          onClick={() => operations.linesRemove([models.lineId])}
          className="justify-self-end p-1 -mr-1"
        >
          <CloseIcon className="font-medium" width="11.5" height="11.5" />
        </button>

        <div className="flex self-center justify-star text-copy">
          <CartLineItem />
        </div>

        <CartLinePrice
          as="span"
          className="justify-self-end self-center text-lg"
        />
      </div>
    </li>
  );
}
